var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("div", { staticClass: "plugin-summary__content" }, [
        _c(
          "p",
          {
            staticClass: "typographies-heading-h3 plugin-summary__content-title"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Mes modules supplémentaires")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "plugins-list" },
          _vm._l(_vm.plugins, function(plugin) {
            return _c("plugin-item", {
              key: plugin.title,
              attrs: { plugin: plugin }
            })
          }),
          1
        )
      ])
    : _c(
        "div",
        { staticClass: "plugin-summary__loading" },
        [_c("CompassLoader", { attrs: { size: "large" } })],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }